import PropTypes from 'prop-types'
import React, {useCallback, useMemo} from 'react'
import RecommendedProducts from '../../../../../components/recommended-products'

const SpareParts = ({product, onRecommendedProductClick}) => {
    const recommendations = product?.recommendations
    const productType = product?.['c_product-type']
    const products = useMemo(
        () =>
            recommendations &&
            productType && [
                {
                    recommendations,
                    type: productType
                }
            ],
        [recommendations, productType]
    )
    const shouldFetch = useCallback(
        () => () => recommendations && productType,
        [recommendations, productType]
    )

    return (
        <RecommendedProducts
            recommender={'custom-SpareParts'}
            products={products}
            shouldFetch={shouldFetch}
            trackingLabel="PDP Spare parts"
            onRecommendedProductClick={onRecommendedProductClick}
        />
    )
}

SpareParts.propTypes = {
    product: PropTypes.object,
    onRecommendedProductClick: PropTypes.func
}

export default SpareParts
